/// <reference path="./origin-assets-module.d.ts" />

import { ORIGIN_ASSETS } from "@origin-assets";

import { type Assets, DEFAULT_ASSETS } from "./model";

export const getOriginAsset = <K extends keyof Assets>(key: K): Assets[K] => {
  return ORIGIN_ASSETS?.[ key ] ?? DEFAULT_ASSETS[ key ];
};
